import {
  Avatar,
  Button,
  InputLabel,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleCircledMinus, PurpleCircledPlus } from 'Images';
import { useContext, useState } from 'react';

const MIN_SUBJECT_VIEW = 3;

export const SortBySubject = () => {
  const { documents, filter, setFilter } = useContext(DocumentsContext);
  const [viewAllSubject, setViewAllSubject] = useState<boolean>(false);

  const subjectTypeOptions = [
    ...new Set(
      [...documents.previousYearsResults].map((doc) => doc.documentSubject)
    ),
  ];

  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  return (
    <Stack>
      <Typography variant='body1'>
        {Dictionary[DICTIONARY.Documents].sortBySubject}
      </Typography>
      <Stack
        direction='row'
        flexWrap='wrap'
        gap='8px'
        component='ul'
        sx={{
          m: '12px 0 0 0',
          p: 0,
        }}
        aria-describedby={
          dictionary.ariaDescriptionSubjectSort && 'tags-description'
        }
      >
        {dictionary.ariaDescriptionSubjectSort && (
          <span className='sr-only' id='tags-description'>
            {dictionary.ariaDescriptionSubjectSort}
          </span>
        )}
        {subjectTypeOptions.map((option: string | undefined, index: number) => {
          if (!option) return null;
          if (!viewAllSubject && index > MIN_SUBJECT_VIEW) return null;
          const isActive = filter.subjectsTypes.includes(option);
          return (
            <ListItem sx={{ padding: 0, width: 'fit-content' }} key={index}>
              <Button
                variant='outlined'
                onClick={() => {
                  const updatedFilter = { ...filter };
                  const index = updatedFilter.subjectsTypes.indexOf(option);
                  if (index < 0) updatedFilter.subjectsTypes.push(option);
                  else updatedFilter.subjectsTypes.splice(index, 1);
                  setFilter(updatedFilter);
                }}
                sx={{
                  padding: '0px 15px',
                  height: '32px',
                  border: '1px solid #E7EDFF',
                  bgcolor: isActive ? '#1552E8' : '#FFF',
                  ':hover': isActive
                    ? {
                        bgcolor: '#1552E8',
                      }
                    : undefined,
                }}
              >
                <InputLabel
                  id={`label-chip-${option.trim().replace(' ', '-')}`}
                >
                  <Typography
                    variant='body6'
                    sx={{
                      cursor: 'pointer',
                      color: isActive ? '#FFF' : '#1552E8',
                    }}
                  >
                    {option}
                  </Typography>
                </InputLabel>
              </Button>
            </ListItem>
          );
        })}
        <Button onClick={() => setViewAllSubject(!viewAllSubject)}>
          <Avatar
            alt=''
            src={viewAllSubject ? PurpleCircledMinus : PurpleCircledPlus}
            sx={{ width: '48px', height: '32px' }}
          />
        </Button>
      </Stack>
    </Stack>
  );
};
